import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row card rounded-0" }
const _hoisted_3 = { class: "col-12 card-header" }
const _hoisted_4 = { class: "d-inline" }
const _hoisted_5 = { class: "col-12 card-body" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "partner-selection" }
const _hoisted_10 = { class: "row p-4 m-auto" }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = { class: "row mt-5" }
const _hoisted_13 = { class: "col-12 text-center" }
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && !_ctx.err_msg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row card text-white rounded-0 top-header" }, [
            _createElementVNode("div", { class: "col-12 text-center" }, [
              _createElementVNode("h2", { class: "my-3 fw-bold" }, "Client Admin Request")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.client_request.user.name), 1),
              _createElementVNode("button", {
                class: "btn btn-sm btn-primary float-end return-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push({name:'management.clients'})))
              }, "Return to Client Requests")
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.client_request.user.name), 1),
                _createElementVNode("h5", null, [
                  _createTextVNode("ID: " + _toDisplayString(_ctx.client_request.user.id) + " | " + _toDisplayString(_ctx.client_request.user.email) + " | " + _toDisplayString(_ctx.moment(_ctx.client_request.created_at).format('MM-DD-YYYY')) + " | ", 1),
                  (_ctx.client_request.is_sim)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Simclusive"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, "SP-ED"))
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "w-75" }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-sm-12 col-md-6",
                      key: partner.id
                    }, [
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.selected_partners[partner.id]) = $event)
                        }, null, 8, _hoisted_11), [
                          [_vModelCheckbox, _ctx.selected_partners[partner.id]]
                        ]),
                        _createTextVNode(" " + _toDisplayString(partner.short_name), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-md",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.approveRequest()))
                  }, "Approve")
                ])
              ])
            ])
          ])
        ]))
      : (!_ctx.loading && _ctx.err_msg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _cache[4] || (_cache[4] = _createElementVNode("h4", null, "Error Loading Application", -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.err_msg), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}